import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {Alert, Button, Collapse, Icon, Menu, Modal} from 'antd'

import cfgDef from './def/default.json'
import {Field, Address} from './fields'
import {Form, Submit, Reset} from 'forms'

import {MessageService, MessageStore} from 'api/message'
import {DeviceService} from 'api/device'
import {Loading} from 'ui'
import {NotFound} from 'pages/NotFound.jsx'

class RequestConfig extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.element.isRequired,
         device:   React.PropTypes.object.isRequired
      }
   }

   constructor() {
      super()

      this.state = {
         loading: false
      }

      this.onClick = this.onClick.bind(this)
   }

   onClick(ev) {
      ev.preventDefault()

      const {network, key} = this.props.device,
         cmd = {
            'proto/tm': {
               command: 'get_config',
               type:    'command'
            }
         }

      this.setState({loading: true})

      MessageService.write(network, key, cmd, false)
         .catch(_err => {
            this.setState({loading: false})
            Modal.error({
               title:   'Failed to refresh send command',
               content: 'Unable to request device configuration',
               okText:  'Try again',
               onOk:    this.onClick
            })
         })
         .then(_resp => {
            this.setState({loading: false})
         })
   }

   render() {
      const {loading} = this.state,
         {device} = this.props

      if (!device) {
         return <NotFound />
      }

      return React.cloneElement(this.props.children, {
         loading,
         onClick: this.onClick
      })
   }
}

const NoConfig = ({device}) => (
   <div>
      <Alert
         showIcon
         type="warning"
         message="No configuration available"
         description={
            <div>
               <p style={{marginBottom: '1em'}}>
                  The configuration for this device have not been received yet
               </p>
               <p>
                  <RequestConfig device={device}>
                     <Button type="primary" icon="reload">
                        Request Config
                     </Button>
                  </RequestConfig>
               </p>
            </div>
         }
      />

   </div>
)

NoConfig.propTypes = {
   device: React.PropTypes.object.isRequired
}

const groupMap = {
   io: [
      'gpio_0',
      'gpio_1',
      'gpio_2',
      'gpio_3',
      'gpio_4',
      'gpio_5',
      'gpio_6',
      'gpio_7',
      'gpio',
      'pulse_counter'
   ],

   device: ['device', 'ima', 'uart', 'end_device'],

   rf: ['net', 'rf', 'rf_jamming', 'cluster'],

   security: ['security']
}

const groupNames = {
   io:       'IO Functions',
   device:   'Device Options',
   rf:       'Radio & Network options',
   security: 'Security'
}

const mapGroup = group => {
   let res = _.pick(groupMap, v => -1 !== _.indexOf(v, group))

   return 0 < _.size(res) ? _.keys(res)[0] : group
}

const iconMap = group => {
   switch (group) {
      case 'device':
         return 'compass'
      case 'io':
         return 'usb'
      case 'rf':
         return 'wifi'
      case 'security':
         return 'safety'
      default:
         return 'api'
   }
}

class FieldSet extends React.Component {
   static get propTypes() {
      return {
         field:  React.PropTypes.string.isRequired,
         device: React.PropTypes.object.isRequired,
         config: React.PropTypes.object.isRequired,
         unsafe: React.PropTypes.object.isRequired,
         merged: React.PropTypes.array.isRequired
      }
   }

   render() {
      const {field, config, merged, unsafe} = this.props,
         definitions = cfgDef[field] || {}

      return (
         <Row className="fieldset">
            <Col xs={12}>
               <h4>{_.get(definitions, '_.label', field)}</h4>

               <Row>
                  {_.map(config[field], (v, k) => {
                     return (
                        <Col key={k} md={4}>
                           <Field
                              spec={definitions[k] || {}}
                              group={field}
                              field={k}
                              merged={-1 !== _.indexOf(merged, field + '.' + k)}
                              unsafe={undefined !== unsafe[field + '.' + k]}
                              value={_.get(config, [field, k])}
                           />
                        </Col>
                     )
                  })}
               </Row>
            </Col>
         </Row>
      )
   }
}

class ConfigFields extends React.Component {
   static get propTypes() {
      return {
         config:   React.PropTypes.object.isRequired,
         unsafe:   React.PropTypes.object,
         merged:   React.PropTypes.array,
         device:   React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         location: React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         unsafe: false,
         merged: []
      }
   }

   static get contextTypes() {
      return {
         form: React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         config: {}
      }
   }

   constructor(props) {
      super()

      this.state = {
         tab: _.get(props, 'location.query.tab', 'device')
      }

      this.handleGroupChange = this.handleGroupChange.bind(this)
      this.requestNewConfig = this.requestNewConfig.bind(this)
   }

   handleGroupChange(ev) {
      const {router, location} = this.props

      if (!ev.key.match(/^\$/)) {
         this.setState({tab: ev.key}, () =>
            router.replace({...location, query: {...location.query, tab: ev.key}})
         )
      }
   }

   requestNewConfig(ev) {
      ev.preventDefault()
   }

   render() {
      let {tab} = this.state,
         {config, unsafe, merged, device} = this.props,
         groups = _.reduce(_.keys(config), (acc, group) => _.uniq(acc.concat(mapGroup(group))), []),
         fields = groupMap[tab] || [tab],
         {patch} = this.context.form.state,
         changeCount = _.reduce(patch, (acc, group) => acc + _.size(group), 0),
         unsafeConfig = 0 < _.size(unsafe) || 0 < _.size(merged)

      return (
         <Row className="config">
            <Col md={3}>
               <h5>Parameters</h5>
               <Menu selectedKeys={[tab]} onClick={this.handleGroupChange}>

                  {_.map(groups, group => (
                     <Menu.Item key={group}>
                        <Icon type={iconMap(group)} /> {groupNames[group] || group}
                     </Menu.Item>
                  ))}

                  <Menu.Divider />

                  <Menu.Item key="$request-config">
                     <RequestConfig device={device}>
                        <Button icon="reload">
                           <b>
                              Request Latest Configuration
                           </b>
                        </Button>
                     </RequestConfig>
                  </Menu.Item>
               </Menu>
            </Col>

            <Col md={9}>
               {changeCount
                  ? <Alert
                       showIcon
                       closeable
                       closeText="Ignore"
                       message="Uncommited changes"
                       type="warning"
                       description={
                          <div>
                             <p>
                                You have
                                {' '}
                                {changeCount}
                                {' '}
                                uncommited changes to device configuration
                             </p>

                             <Collapse style={{background: 'transparent', border: 0}}>
                                <Collapse.Panel
                                   header="Show changes"
                                   style={{
                                      background:   'transparent',
                                      border:       0,
                                      marginBottom: '1em'
                                   }}
                                >
                                   <pre>{JSON.stringify(patch, null, 2)}</pre>
                                </Collapse.Panel>
                             </Collapse>

                             <p>
                                <Submit type="danger">Commit Changes</Submit>
                                &nbsp;
                                <Reset>Reset Form</Reset>
                             </p>
                          </div>
                       }
                    />
                  : null}

               {unsafeConfig &&
                  !changeCount &&
                  <Alert
                     showIcon
                     closeable
                     closeText="Ignore"
                     message="Stale Config"
                     type="warning"
                     description={
                        <div>
                           <p>
                              All changes to configuration have not been acknowledged, some
                              parameters may be invalid. Request device configuration to ensure
                              the configuration is up to date.
                           </p>

                           <p>
                              <RequestConfig device={device}>
                                 <Button type="default" icon="reload">
                                    Request Device Configuration
                                 </Button>
                              </RequestConfig>
                           </p>
                        </div>
                     }
                  />}

               <Form.Error>
                  <h5>Failed to commit configuration</h5>
               </Form.Error>

               <Form.Updated>
                  Device configuration successfully committed!
               </Form.Updated>

               {_.map(fields, field => (
                  <FieldSet
                     key={field}
                     field={field}
                     config={config}
                     unsafe={unsafe || false}
                     merged={merged || []}
                     device={device}
                  />
               ))}

               <p className="text-right">
                  <Submit type="danger">Commit Changes</Submit>
                  &nbsp;
                  <Reset>Reset Form</Reset>
               </p>
            </Col>
         </Row>
      )
   }
}

class ConfigState extends React.Component {
   static get propTypes() {
      return {
         device:      React.PropTypes.object.isRequired,
         configState: React.PropTypes.array.isRequired,
         children:    React.PropTypes.node.isRequired
      }
   }

   static get defaultProps() {
      return {
         device: {}
      }
   }

   constructor() {
      super()

      this.state = {
         loading:  null,
         config:   {},
         messages: null
      }

      this._mounted = false

      this.onCommit = this.onCommit.bind(this)
      this.transformChanges = this.transformChanges.bind(this)
   }

   componentWillMount() {
      this._mounted = true

      if (this.props.configState) {
         this.expandConfigState(this.props.configState)
      }
   }

   componentWillUnmount() {
      this._mounted = false
   }

   componentWillReceiveProps(next) {
      if (_.eq(next.configState, this.props.configState)) {
         return
      }

      this.expandConfigState(next.configState)
   }

   // find the keys of all config related messages and set state's `messages` to
   // the expanded msg
   expandConfigState(configState) {
      let msgs = MessageStore.matches(({key}) => -1 !== _.indexOf(configState, key)),
         missing = _.reject(configState, a => _.some(msgs, ({key}) => key === a))

      if (missing) {
         this.setState({loading: true})
         Promise.all(_.map(missing, k => MessageService.read(k, true))).then(_res => {
            this.setState({
               messages: MessageStore.matches(({$key}) => -1 !== _.indexOf(configState, $key)),
               loading:  false
            })
         })
      } else {
         this.setState({messages: msgs, loading: false})
      }
   }

   onCommit(ev, patch, _input) {
      const {network, key} = this.props.device

      return new Promise(
         function(resolve, reject) {
            MessageService.write(
               network,
               key,
               {
                  'proto/tm': {
                     type:    'command',
                     command: 'set_config',
                     config:  patch
                  }
               },
               false
            )
               .then(resp => {
                  if (_.isError(resp)) {
                     reject(resp)

                     return resp
                  }

                  // @todo typically NAK's would not exist due to a perfect configuration
                  // beeing sent. However config parser/definitions/user input may be
                  // invalid so check the NAK as well.
                  this.onIncoming = msgs => {
                     let ctrl = _.filter(
                        msgs,
                        msg =>
                           resp.datetime < msg.datetime &&
                           'sleep_or_config' === msg['proto/tm'].trigger
                     )

                     if (0 < ctrl.length) {
                        this.onIncoming = null
                        if (this._incomingTimeout) {
                           clearTimeout(this._incomingTimeout)
                        }

                        DeviceService.fetch(network, key)
                           .then(() => resolve(ctrl[0]))
                           .catch(err => reject(err))
                     }
                  }

                  this._incomingTimeout = setTimeout(() => {
                     this.onIncoming = null
                     reject(new Error('No reply from device after 15 seconds'))
                  }, 15000)

                  return resp
               })
               .catch(e => reject(e))
         }.bind(this)
      )
   }

   transformChanges(fields, path) {
      // parse everything as integer unless `type` is specified
      return _.mapValues(fields, (v, k) => {
         let realpath = (path || []).concat(k)

         if (_.isPlainObject(v)) {
            return this.transformChanges(v, realpath)
         } else {
            switch (_.get(cfgDef, realpath, {}).type) {
               case 'address':
                  return Address.transform(v)
               default:
                  return parseInt(v, 10)
            }
         }
      })
   }

   stateToConfig(configState, messages) {
      let expanded = _.map(configState, key =>
         _.find(messages, msg => undefined !== msg && key === (msg.$key || msg.key))
      )

      return _.reduce(
         expanded,
         ({config, unsafe, staged, merged}, msg) => {
            if (!msg) {
               return {config, unsafe, staged}
            }

            let proto = msg['proto/tm']

            if ('config' === proto.detail) {
               return {config: proto.config, unsafe: {}, staged: [], merged: []}
            } else if ('reset' === proto.detail && 'sleep_or_config' === proto.trigger) {
               let [newcfg, fields] = _.reduce(
                  staged,
                  ([acc, mergefields], [_k, cfg]) => {
                     let newfields = []

                     _.each(cfg, (f, group) =>
                        _.each(f, (_v, k) => newfields.push(group + '.' + k))
                     )

                     return [_.merge(acc, cfg), mergefields.concat(newfields)]
                  },
                  [config, []]
               )

               return {
                  config: newcfg,
                  unsafe: {},
                  staged: [],
                  merged: merged.concat(fields)
               }
            } else if ('set_config' === proto.command) {
               staged.push([msg.key, proto.config])

               _.each(proto.config, (fields, group) =>
                  _.each(fields, (v, k) => (unsafe[group + '.' + k] = v))
               )

               return {config, unsafe, staged, merged}
            }

            return {config, unsafe, staged, merged}
         },
         {config: {}, unsafe: {}, staged: [], merged: []}
      )
   }

   render() {
      const {loading, messages} = this.state,
         {configState} = this.props,
         {config, unsafe, staged, merged} = this.stateToConfig(configState, messages)

      return (
         <Loading loading={loading}>
            <Form input={config} transform={this.transformChanges} onSubmit={this.onCommit}>
               {React.cloneElement(this.props.children, {
                  config,
                  unsafe,
                  staged,
                  merged
               })}
            </Form>
         </Loading>
      )
   }
}

export class Configuration extends React.Component {
   constructor() {
      super()

      this.state = {
         configState: null,
         loading:     true
      }
   }

   componentWillMount() {
      this._mounted = true
      this.awaitConfigHandler(this.props)
   }

   componentWillReceiveProps(next) {
      if (!_.eq(next.queryStream, this.props.queryStream)) {
         if (this.props.queryStream) {
            this.props.queryStream.removeMsgHandler(this._onMsg)
         }

         this.awaitConfigHandler(next)
      }
   }

   componentWillUnmount() {
      this._mounted = false
      if (this.props.queryStream) {
         this.props.queryStream.removeMsgHandler(this._onMsg)
      }
   }

   awaitConfigHandler({device, queryStream}) {
      if (!queryStream) {
         return
      }
      const content = 'An unknown error occured when reloading the device resource.'

      this._onMsg = msg => {
         let deviceState = _.get(device, 'proto/tm.config')

         if (!this._mounted) {
            return
         }

         if ('config' === msg['proto/tm'].detail) {
            this.setState({configState: [msg.$key || msg.key], loading: false})
         } else {
            this.setState(state =>
               _.set(
                  {...state, loading: false},
                  'configState',
                  (state.configState || deviceState || []).concat(msg.$key || msg.key)
               )
            )
         }

         this.setState({loading: true})
         DeviceService.fetch(device.network, device.key)
            .catch(err => {
               if (this._mounted) {
                  this.setState({loading: false})
               }
               Modal.error({
                  title: 'Failed to refresh Device Resource',
                  content
               })
            })
            .then(resp => {
               if (!this._mounted) {
                  return
               }
               // fallback in case device wasn't updated
               if (resp['proto/tm'] && !_.eq(deviceState, resp['proto/tm'].config)) {
                  this.setState({configState: null, loading: false})
               } else {
                  this.setState({loading: false})
               }
            })
      }

      const matchfun = msg => {
         let proto = msg['proto/tm']

         return (
            'config' === proto.detail ||
            ('reset' === proto.detail && 'sleep_or_config' === proto.trigger) ||
            'set_config' === proto.command
         )
      }

      queryStream.addMsgHandler(matchfun, this._onMsg)
      this.setState({loading: false})
   }

   render() {
      let {device, ...props} = this.props,
         {configState, loading} = this.state

      if (!configState) {
         configState = _.get(device, 'proto/tm.config', null)
      }

      if (loading) {
         return (
            <Loading
               loading={loading}
               overlay={true}
               style={{position: 'relative', width: '56px', height: '56px', margin: '5em auto'}}
            >
               <p className="text-center" style={{paddingTop: '100px'}}>
                  Loading configuration from cache. Please wait a moment.
               </p>
            </Loading>
         )
      }

      if (configState) {
         return (
            <div>
               <ConfigState device={device} configState={configState}>
                  <ConfigFields device={device} {...props} />
               </ConfigState>
            </div>
         )
      } else {
         return <NoConfig device={device} />
      }
   }
}

Configuration.propTypes = {
   device:      React.PropTypes.object,
   messages:    React.PropTypes.array,
   queryStream: React.PropTypes.object
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/index.jsx